import r from "../managers/braze-instance.js";
import vt from "./utils/push-utils.js";
export function isPushPermissionGranted() {
  if (r.rr()) return vt.isPushPermissionGranted();
}
